import { Fragment, useEffect } from 'react';
import styled from 'styled-components';
import { InverseButton, PrimaryButton } from '@crehana/ui';
import { date } from '@crehana/utils';
import { usePlaybackContext } from "../context/Playback";
import { useResponsiveContext } from "../context/Responsive";
import { useUIContext } from "../context/UI";
import { useTranslation } from "../hooks";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var Wrapper = /*#__PURE__*/styled.div.withConfig({
  componentId: "sc-4533uc-0"
})(["\n  &.is-visible {\n    visibility: visible;\n    opacity: 1;\n    transition: opacity 150ms linear;\n  }\n  &.is-hidden {\n    visibility: hidden;\n    opacity: 0;\n    transition: visibility 0s 150ms, opacity 150ms linear;\n  }\n"]);
var LeaveConfirmation = function LeaveConfirmation(_ref) {
  var _ref$confirmation = _ref.confirmation,
    onShown = _ref$confirmation.onShown,
    username = _ref$confirmation.username,
    jsxBody = _ref$confirmation.jsxBody;
  var _useResponsiveContext = useResponsiveContext(),
    playerSize = _useResponsiveContext.playerSize;
  var _usePlaybackContext = usePlaybackContext(),
    duration = _usePlaybackContext.duration,
    currentProgress = _usePlaybackContext.currentProgress,
    remainingSeconds = _usePlaybackContext.remainingSeconds;
  var _useUIContext = useUIContext(),
    leaveConfirmation = _useUIContext.leaveConfirmation,
    onBackCancel = _useUIContext.onBackCancel,
    onBackConfirm = _useUIContext.onBackConfirm;
  var visibleJsxBodyByPlayerSize = jsxBody === null || jsxBody === void 0 ? void 0 : jsxBody.visibleByPlayerSize;
  var shouldRenderJsxBody = (!visibleJsxBodyByPlayerSize || visibleJsxBodyByPlayerSize[playerSize.value]) && (jsxBody === null || jsxBody === void 0 ? void 0 : jsxBody.renderFn);
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  useEffect(function () {
    if (onShown && leaveConfirmation) {
      onShown({
        duration: duration,
        remainingSeconds: remainingSeconds,
        currentProgress: currentProgress
      });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [leaveConfirmation]);
  return /*#__PURE__*/_jsx(Wrapper, {
    className: "absolute inset-0 z-5 flex flex-col items-center justify-".concat(shouldRenderJsxBody ? 'end' : 'center', " text-center bg-base-main-80 ").concat(leaveConfirmation ? 'is-visible' : 'is-hidden'),
    children: playerSize.matches.sm ? /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("h2", {
        className: "mb-24 text-white font-h2",
        children: username ? t('CONFIRMATION_TITLE_W_NAME', {
          interpolation: {
            name: username
          }
        }) : t('CONFIRMATION_TITLE')
      }), /*#__PURE__*/_jsx("p", {
        className: "mb-32 text-white font-subtitle1",
        children: t('CONFIRMATION_DETAIL', {
          interpolation: {
            minutes: date.toMinutes(remainingSeconds)
          }
        })
      }), /*#__PURE__*/_jsxs("div", {
        className: "flex items-center justify-center",
        children: [/*#__PURE__*/_jsx(InverseButton, {
          label: t('CONFIRMATION_LEAVE'),
          size: "l",
          isDark: true,
          isWhite: true,
          onClick: onBackConfirm
        }), /*#__PURE__*/_jsx(PrimaryButton, {
          className: "ml-24",
          label: t('CONFIRMATION_CONTINUE'),
          size: "l",
          isDark: true,
          onClick: onBackCancel
        })]
      }), shouldRenderJsxBody && (jsxBody === null || jsxBody === void 0 ? void 0 : jsxBody.renderFn) && /*#__PURE__*/_jsxs("div", {
        className: "my-8",
        children: [" ", jsxBody.renderFn(), " "]
      })]
    }) : /*#__PURE__*/_jsxs("div", {
      className: "flex flex-col px-40",
      children: [/*#__PURE__*/_jsx("h2", {
        className: "mb-16 text-white font-h4",
        children: t('CONFIRMATION_TITLE')
      }), /*#__PURE__*/_jsx(PrimaryButton, {
        className: "mb-16",
        label: t('CONFIRMATION_CONTINUE'),
        size: playerSize.matches.xs ? 's' : 'xs',
        isDark: true,
        full: true,
        onClick: onBackCancel
      }), /*#__PURE__*/_jsx(InverseButton, {
        label: t('CONFIRMATION_LEAVE'),
        size: playerSize.matches.xs ? 's' : 'xs',
        isDark: true,
        isWhite: true,
        full: true,
        onClick: onBackConfirm
      })]
    })
  });
};
export default LeaveConfirmation;